import { Component, OnInit, HostListener } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
@Component({
  selector: 'app-bollywood-subtext',
  templateUrl: './bollywood-subtext.component.html',
  styleUrls: ['./bollywood-subtext.component.scss']
})
export class BollywoodSubtextComponent implements OnInit {
  windowsWidth;
  facebookUrl = '';
  bgColor = '#efe4e6';
  buttonShare = false;

  soundIcon = false;
  imageIcon = '../cinemaissue/assets/images/Sound_Bollywood_White_cross.svg';
  playing;

  constructor() { }

  ngOnInit() {
    this.windowsWidth = window.innerWidth;
    this.playing = false;
    this.goBackToTop();
    this.facebookUrl = window.location.href;
  }

  gotoTop() {
    document.getElementById('parentWrap').scrollTo({'top': 0, behavior: 'smooth'});
  }

  goBackToTop() {
    document.getElementsByTagName('body')[0].scroll({
      top: 0,
      behavior: 'smooth'
    });
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.windowsWidth = window.innerWidth;
  }

  pauseAndPlayAudio() {
    if (this.playing === false) {
      this.playing = true;
      (document.querySelector('#bollywoodSubtextGIFTrack') as HTMLMediaElement).play();
      (document.querySelector('#bollywoodSubtextGIFTrack') as HTMLMediaElement).autoplay = true;
      (document.querySelector('#bollywoodSubtextGIFTrack') as HTMLMediaElement).loop = true;
      this.soundIcon = !this.soundIcon;
    if (this.imageIcon === '../cinemaissue/assets/images/Sound_Bollywood_White_cross.svg') {
      this.imageIcon = '../cinemaissue/assets/images/Sound_Bollywood_White.svg';
    } else {
      this.imageIcon = '../cinemaissue/assets/images/Sound_Bollywood_White_cross.svg';
    }
    } else {
      this.soundIcon = !this.soundIcon;
        if (this.imageIcon === '../cinemaissue/assets/images/Sound_Bollywood_White.svg') {
          this.imageIcon = '../cinemaissue/assets/images/Sound_Bollywood_White_cross.svg';
        } else {
          this.imageIcon = '../cinemaissue/assets/images/Sound_Bollywood_White.svg';
        }
      (document.querySelector('#bollywoodSubtextGIFTrack') as HTMLMediaElement).pause();
      (document.querySelector('#bollywoodSubtextGIFTrack') as HTMLMediaElement).autoplay = false;
      (document.querySelector('#bollywoodSubtextGIFTrack') as HTMLMediaElement).loop = false;
      this.playing = false;
    }
  }

  shareButton() {
    this.buttonShare = !this.buttonShare;
    if (this.buttonShare === true) {
      document.getElementById('sharePopup').style.display = 'flex';
    } else {
      document.getElementById('sharePopup').style.display = 'none';
    }
  }

}
